import { render } from "./MasaustuUyarisi.vue?vue&type=template&id=76094370"
import script from "./MasaustuUyarisi.vue?vue&type=script&lang=js"
export * from "./MasaustuUyarisi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__